



























































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import ModalImage from '@/app/ui/components/ImageGallery/index.vue'
import ImageSelect from '@/app/ui/components/SelectImage/index.vue'
import { MasterCarStateDataModule } from '@/app/store/modules/masterCar'
import vueCustomScrollbar from 'vue-custom-scrollbar'

import { Vuelidate } from 'vuelidate'
import { Validate } from 'vuelidate-property-decorators'
import {
  required,
  minLength,
  maxLength,
  not,
  sameAs,
} from 'vuelidate/lib/validators'
import { defaultImage } from '@/utils/default'
@Component({
  components: {
    'modal-image': ModalImage,
    'image-select': ImageSelect,
    vueCustomScrollbar,
  },
})
export default class extends Vue {
  @Prop({}) public idModal
  @Prop({}) public imageDataCategory
  @Prop({}) public isLoading
  public $v: Vuelidate

  @Validate({
    required,
    minLength: minLength(4),
    maxLength: maxLength(255),
  })
  public name = ''
  public statusTraining: boolean = true
  public statusSOP: boolean = true
  public carType = ''
  public optionscarType = [
    // di map dari master car
    { value: '', text: 'SOP' },
    { value: 'Passenger Car', text: 'Passenger Car' },
    { value: 'Light Commercial Vehicle', text: 'Light Commercial Vehicle' },
  ]
  public optionsStatus = [
    { value: true, text: 'Active' },
    { value: false, text: 'Inactive' },
  ]
  public statusTrainingOptions = [
    { value: true, text: 'Active' },
    { value: false, text: 'Inactive' },
  ]
  public statusSOPOptions = [
    { value: true, text: 'Active' },
    { value: false, text: 'Inactive' },
  ]
  public resetAdd() {
    this.$v.name.$reset()
    this.name = ''
    this.statusTraining = true
    this.statusSOP = true
    this.carType = ''
    this.stateCarType = false
    this.stateStatus = false
    this.stateTraining = false
    this.stateSOP = false
    this.stateCoverImage = false
    this.stateThumbnailImage = false
    this.stateLogoImage = false
    this.imageCoverId = {
      id: null,
      link: defaultImage,
    }
    this.imageThumbnailId = {
      id: null,
      link: defaultImage,
    }
    // this.imageLogoId = {
    //   id: null,
    //   link: defaultImage,
    // }
  }
  public onClearSelected() {
    this.$emit('onClearSelected')
  }

  public imageCoverId: any = {
    id: null,
    link: defaultImage,
  }
  public imageThumbnailId: any = {
    id: null,
    link: defaultImage,
  }
  public imageLogoId: any = {
    id: 3,
    link: defaultImage,
  }

  public logo: string = 'logo'
  public cover: string = 'cover'
  public thumbnail: string = 'thumbnail'

  public changeImageCoverId(item) {
    this.stateCoverImage = false
    this.imageCoverId.id = item.id
    this.imageCoverId.link = item.link
  }

  public changeImageThumbnailId(item) {
    this.stateThumbnailImage = false
    this.imageThumbnailId.id = item.id
    this.imageThumbnailId.link = item.link
  }
  // public changeImageLogoId(item) {
  //   this.stateLogoImage = false
  //   this.imageLogoId.id = item.id
  //   this.imageLogoId.link = item.link
  // }

  public cancelImageThumbnailId() {
    this.stateThumbnailImage = false
    this.imageThumbnailId.id = null
    this.imageThumbnailId.link = defaultImage
  }
  public cancelImageCoverId() {
    this.stateCoverImage = false
    this.imageCoverId.id = null
    this.imageCoverId.link = defaultImage
  }
  // public cancelImageLogolId() {
  //   this.stateLogoImage = false
  //   this.imageLogoId.id = null
  //   this.imageLogoId.link = defaultImage
  // }
  public stateCoverImage = false
  public stateThumbnailImage = false
  public stateLogoImage = false
  public stateCarType = false
  public stateStatus = false
  public stateTraining = false
  public stateSOP = false

  public postData() {
    //  console.log(this.imageLogoId.id)
    //  console.log(this.imageLogoId.link)
    this.$v.name.$touch()
    if (
      this.$v.name.$invalid ||
      this.imageCoverId.id === null ||
      this.imageThumbnailId.id === null ||
      this.imageLogoId.id === null
    ) {
      this.imageCoverId.id === null
        ? (this.stateCoverImage = true)
        : (this.stateCoverImage = false)
      this.imageThumbnailId.id === null
        ? (this.stateThumbnailImage = true)
        : (this.stateThumbnailImage = false)
      this.imageLogoId.id === null
        ? (this.stateLogoImage = true)
        : (this.stateLogoImage = false)
      this.stateCarType = true
      this.stateTraining = true
      this.stateSOP = true
    } else {
      const dataToPost = {
        name: this.name,
        trainingActive: this.statusTraining,
        sopActive: this.statusSOP,
        imageCoverId: this.imageCoverId.id,
        imageThumbnailId: this.imageThumbnailId.id,
        imageLogoId: this.imageLogoId.id,
        tag: this.carType,
      }
      MasterCarStateDataModule.postMasterCar(dataToPost)
      this.$root.$emit('bv::hide::modal', this.idModal)
    }
  }
}
